import { handleActions } from 'redux-actions';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { combineReducers } from 'redux';
import { products as productsAPI } from 'api';
import { getEntities } from 'selectors';
import { products } from 'schemas';
import { getProductApiHOC } from '../selectors';
import { types } from './actions';

export const getIsFetching = state => getProductApiHOC(state).isFetching;

export const getProduct = createSelector(
  state => getProductApiHOC(state).result,
  state => getEntities(state),

  (result, entities) => denormalize(
    result,
    products.productSchema,
    entities,
  ),
);

export default combineReducers({
  isFetching: handleActions({
    [productsAPI.types.GET_PRODUCT_REQUEST]: () => true,
    [productsAPI.types.GET_PRODUCT_SUCCESS]: () => false,
    [productsAPI.types.GET_PRODUCT_FAILURE]: () => false,
  }, false),

  result: handleActions({
    [productsAPI.types.GET_PRODUCT_SUCCESS]: (state, { payload: { result } }) => result,
    [types.PRODUCT_API_HOC_RESET]: () => null,
  }, null),
});



// WEBPACK FOOTER //
// ./src/components/apiHOCs/ProductApiHOC/reducers.js